import { Card } from '@ps/isp-web-component-library';
import { MarketLevelMarketTemplateId } from '@ps/isp-web-services-types';
import React from 'react';

import { MarketTemplate, OddsBoostEventLink } from '@swf/sports/components';
import { useNormalisedEventBasedData } from '@swf/sports/hooks/useNormalisedEventBasedData';

import styles from './OddsBoostEventCard.scss';

interface Props {
  marketId: string;
}

const OddsBoostEventCard: React.FC<Props> = ({ marketId }) => {
  const { market, event, eventType, competition } = useNormalisedEventBasedData({ marketId });

  return market ? (
    <Card className={styles.card} data-testid="sports-odds-boost-events-card">
      <OddsBoostEventLink
        event={event}
        market={market}
        eventTypeSlug={eventType.eventTypeSlug}
        competitionSlug={competition.competitionSlug}
      />
      <div>
        <MarketTemplate
          marketId={market.marketId}
          templateId={MarketLevelMarketTemplateId.ODDS_BOOST}
        />
      </div>
    </Card>
  ) : null;
};

export default OddsBoostEventCard;
